import { VALID_AREA_CODE, NOT_VALID_AREA_CODE } from '../actions/actionTypes'

const initialState = {
    isAcceptedPostalCode: true,
}

export const areaCodeReducer = (state = initialState, action) => {
    switch(action.type) {
        case VALID_AREA_CODE: {
            return {
                isAcceptedPostalCode: true
            }
        }
        case NOT_VALID_AREA_CODE: {
            return {
                isAcceptedPostalCode: false
            }
        }
    }
    return state
}
